
import { Component, Vue } from 'vue-property-decorator'

import BacButton from '@/components/BacButton.vue'
import BacModal from '@/components/BacModal.vue'
import { Game } from '../../lib/models/Game'
import { Http } from '@/lib/utils/Http'
import UIkit from 'uikit'
import BacMultiselectWrapper from '@/components/BacMultiselectWrapper.vue'
import Multiselect from 'vue-multiselect'

@Component({
  components: {
    BacButton,
    BacModal,
    BacMultiselectWrapper,
    Multiselect
  }
})
export default class RallyChallengeChooser extends Vue {
  allChallenges: Game[] = []
  selectedChallenge: Game = new Game()

  rallyRoundChallenges: Game[] = []

  isAddingButton = false

  headers = [
    { text: 'Name', value: 'name', width: 80 }
  ]

  get items () {
    return this.rallyRoundChallenges
  }

  get allChallengesMultiselectArray () {
    return this.allChallenges.map(challenge => {
      return { id: challenge.id, name: challenge.name }
    })
  }

  addChallenge (name: string) {
    const game = new Game()
    game.name = name
    this.allChallenges.push(game)
    this.rallyRoundChallenges.push(game)
  }

  mounted () {
    this.loadRallyRoundChallenges()
    this.loadAllChallenges()
  }

  async loadAllChallenges () {
    this.allChallenges = await Game.getAllChallenges({})
  }

  async loadRallyRoundChallenges () {
    this.rallyRoundChallenges = await Game.getForRallyRound(parseInt(this.$route.params.rallyRoundId))
  }

  async saveButton () {
    if (this.isAddingButton) {
      return
    }
    this.isAddingButton = true

    if (!this.selectedChallenge.rallyRoundId) {
      this.selectedChallenge.rallyRoundId = parseInt(this.$route.params.rallyRoundId)
    }

    const res = await Http.request(`/api/rally-round/${this.selectedChallenge.rallyRoundId}/challenges`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(this.rallyRoundChallenges)
    })

    if (res.status !== 200) {
      UIkit.notification({
        message: 'Es ist ein unbekannter Fehler aufgetreten! Bitte an Entwickler melden!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
    } else {
      UIkit.notification({
        message: 'Challenges gespeichert!',
        status: 'success',
        timeout: 5000,
        pos: 'bottom-center'
      })
      UIkit.modal('#add-challenge-modal').hide()
    }
    this.isAddingButton = false
    this.loadRallyRoundChallenges()
    this.loadAllChallenges()
  }
}
